import { useQuery } from '@tanstack/react-query';
import { DocumentsService } from 'api';
import {
  FIRM_DOCUMENT_COMPANIES_QUERY_KEY,
  FIRM_DOCUMENT_COMPANIES_QUERY_STALE_TIME_MS,
} from './useFirmDocumentCompaniesQuery.constants';
import type { UseFirmDocumentCompaniesQueryParams } from './useFirmDocumentCompaniesQuery.types';
import { getNormalizedSearch } from '../documentsQuery.utils';

export const useFirmDocumentCompaniesQuery = ({
  firmId,
  fundId = null,
  search,
}: UseFirmDocumentCompaniesQueryParams) => {
  const normalizedSearch = getNormalizedSearch(search);

  return useQuery({
    enabled: Boolean(firmId),
    queryFn: () =>
      DocumentsService.apiDocumentsFirmsCompaniesList(
        String(firmId),
        normalizedSearch,
        fundId ?? undefined,
        'name'
      ),
    queryKey: [FIRM_DOCUMENT_COMPANIES_QUERY_KEY, firmId, normalizedSearch ?? '', fundId],
    staleTime: FIRM_DOCUMENT_COMPANIES_QUERY_STALE_TIME_MS,
  });
};
